// ✅ تهريب النصوص قبل إدراجها في HTML خام (طباعة التقارير وكشف الديون) — حتى لا يُفسَّر
//    اسم أو ملاحظة تحتوي على < أو > أو " كوسوم HTML.
export const escapeHtml = v => String(v ?? '')
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
